import React, { Component, Fragment } from "react";
import {
  FormGroup,
  ControlLabel,
  Row,
  Col,
  FormControl,
  Checkbox,
  HelpBlock,
} from "react-bootstrap";
import LoaderButton from "../Component/LoaderButton";
import { fillWayneExpungmentForm } from "../libs/API";

class WayneExpungement extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      caseNumber: "",
      caseDate: "",
      expDate: "",
      name: "",
      docketNumber: "",
      clerkName: "",
      clerkId: "",
      comments: "",
      isAppendFile: "",
      isPrependExistingFile: "",
      characterCount: 0,
    };

    console.log("WayneExpungement popup props", props);
  }

  async componentDidMount() {
    const selectedRow = this.props.selectedRow;

    let caseNumber = "";
    //let caseDate = "";

    if (selectedRow && selectedRow.length > 0) {
      caseNumber = selectedRow[0]["Arrest Number"] || "";
      //caseDate = selectedRow[0]["DoB"] || "";
    }

    this.setState({
      caseNumber,
      //caseDate,
    });
  }

  handleComment = (e) => {
    this.setState({
      characterCount: e.target.value.length,
      comments: e.target.value,
    });
  };

  handleWayneExpungementSubmit = async (e) => {
    e.preventDefault();

    this.setState({ isLoading: true });

    const jObject = {
      "Case#": this.state.caseNumber,
      //CaseDate: this.props.getFormattedDate(new Date(this.state.caseDate)),
      Name: this.state.name,
      "Docket#": this.state.docketNumber,
      DateExpunged: this.props.getFormattedDate(new Date(this.state.expDate)),
      ClerkName: this.state.clerkName,
      ClerkID: this.state.clerkId,
      Comments: this.state.comments,
    };

    const jArray = [];

    jArray.push(jObject);

    jArray.push({
      fileId: this.props.selectedRow[0].FileId,
    });

    const isAppendFile =
      this.state.isAppendFile === null || this.state.isAppendFile === ""
        ? false
        : true;

    const isPrependExistingFile =
      this.state.isPrependExistingFile === null ||
      this.state.isPrependExistingFile === ""
        ? false
        : true;

    jArray.push({
      isAppendFile: isAppendFile,
      isPrependExistingFile: isPrependExistingFile,
    });

    fillWayneExpungmentForm(jArray)
      .then((data) => {
        if (data.status === 200) {
          this.setState({ isLoading: false });
          this.props.closeParentPopup();
        } else {
          this.setState({ isLoading: false });
          alert("Expungement failed. Please try again.");
        }
      })
      .catch((err) => {
        console.log(err);

        this.setState({ isLoading: false });
        alert("Expungement failed. Please try again.");
      });
  };

  render() {
    return (
      <Fragment>
        <form onSubmit={this.handleWayneExpungementSubmit}>
          {/* Case Number */}
          <FormGroup controlId="caseNumber">
            <Row>
              <Col sm={4} componentClass={ControlLabel}>
                Arrest #:
              </Col>

              <Col sm={8}>
                <FormControl
                  className="input-box"
                  type="text"
                  required
                  readOnly
                  value={this.state.caseNumber}
                />
              </Col>
            </Row>
          </FormGroup>

          {/* Case Date */}
          {/* <FormGroup controlId="caseDate">
            <Row>
              <Col sm={4} componentClass={ControlLabel}>
                Case Date:
              </Col>

              <Col sm={8}>
                <FormControl
                  className="input-box"
                  type="date"
                  readOnly
                  value={this.state.caseDate}
                />
              </Col>
            </Row>
          </FormGroup>*/}

          {/* Name */}
          <FormGroup controlId="name">
            <Row>
              <Col sm={4} componentClass={ControlLabel}>
                Name:
              </Col>
              <Col sm={8}>
                <FormControl
                  className="input-box"
                  type="text"
                  onChange={(e) => this.setState({ name: e.target.value })}
                />
              </Col>
            </Row>
          </FormGroup>

          {/* Docket # */}
          <FormGroup controlId="docketNumber">
            <Row>
              <Col sm={4} componentClass={ControlLabel}>
                Docket#:
              </Col>
              <Col sm={8}>
                <FormControl
                  className="input-box"
                  type="text"
                  onChange={(e) =>
                    this.setState({ docketNumber: e.target.value })
                  }
                />
              </Col>
            </Row>
          </FormGroup>

          {/* Expungement Date */}
          <FormGroup controlId="expDate">
            <Row>
              <Col sm={4} componentClass={ControlLabel}>
                Date Expunged:
              </Col>

              <Col sm={8}>
                <FormControl
                  className="input-box"
                  type="date"
                  onChange={(e) =>
                    this.setState({
                      expDate: e.target.value,
                    })
                  }
                />
              </Col>
            </Row>
          </FormGroup>

          {/* Clerk Name */}
          <FormGroup controlId="clerkName">
            <Row>
              <Col sm={4} componentClass={ControlLabel}>
                Clerk Name:
              </Col>
              <Col sm={8}>
                <FormControl
                  className="input-box"
                  type="text"
                  onChange={(e) => this.setState({ clerkName: e.target.value })}
                />
              </Col>
            </Row>
          </FormGroup>

          {/* Clerk ID */}
          <FormGroup controlId="clerkId">
            <Row>
              <Col sm={4} componentClass={ControlLabel}>
                Clerk ID:
              </Col>
              <Col sm={8}>
                <FormControl
                  className="input-box"
                  type="text"
                  onChange={(e) => this.setState({ clerkId: e.target.value })}
                />
              </Col>
            </Row>
          </FormGroup>

          {/* Comments */}
          <FormGroup controlId="comments">
            <Row>
              <Col sm={4} componentClass={ControlLabel}>
                Comments:
              </Col>

              <Col sm={8}>
                <FormControl
                  componentClass="textarea"
                  onChange={this.handleComment}
                  maxLength={400}
                />
              </Col>
            </Row>

            <HelpBlock>
              Total Characters for Expungement Comment is limited to{" "}
              {this.state.characterCount}/400.
            </HelpBlock>
          </FormGroup>

          {/* Submit + Append */}
          <FormGroup>
            <Row>
              <Col sm={4}>
                <LoaderButton
                  block
                  bsClass="btn btn-outline-secondary"
                  disabled={this.state.isLoading}
                  type="submit"
                  isLoading={this.state.isLoading}
                  text="Expunge Record"
                  loadingText="Expunging Record..."
                />
              </Col>

              <Col sm={8}>
                <Checkbox
                  onChange={(e) =>
                    this.setState({
                      isAppendFile: e.target.checked,
                    })
                  }
                >
                  {"   "} Append to Existing Expungement
                </Checkbox>
              </Col>
            </Row>
          </FormGroup>

          {/* Expunge and Retain */}
          <FormGroup>
            <Row>
              <Col sm={4}></Col>

              <Col sm={8}>
                <Checkbox
                  onChange={(e) =>
                    this.setState({
                      isPrependExistingFile: e.target.checked,
                    })
                  }
                >
                  {"   "} Expunge and retain file
                </Checkbox>
              </Col>
            </Row>
          </FormGroup>
        </form>
      </Fragment>
    );
  }
}

export default WayneExpungement;
